(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f1-certificates-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const root = document.getElementById("quality-control");
  if (!root) return;

  const tabs = root.querySelectorAll(".quality-tab");
  const panels = root.querySelectorAll(".tab-panel");
  const badges = root.querySelectorAll(".badge");

  function activateTab(tabId) {
    // Tabs
    tabs.forEach(t => {
      const isActive = t.dataset.tab === tabId;
      t.classList.toggle("active", isActive);
      t.setAttribute("aria-selected", isActive ? "true" : "false");
      t.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    // Panels
    panels.forEach(p => {
      p.classList.toggle("active", p.id === tabId);
    });

    // Badges
    badges.forEach(b => {
      b.classList.toggle("active", b.dataset.badge === tabId);
    });
  }

  // Init: activate the first available tab in DOM order
  if (tabs.length) {
    activateTab(tabs[0].dataset.tab);
  }

  // Click + keyboard support
  tabs.forEach(tab => {
    tab.addEventListener("click", () => activateTab(tab.dataset.tab));
    tab.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activateTab(tab.dataset.tab);
      }
      // Optional: arrow key nav
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        e.preventDefault();
        const arr = Array.from(tabs);
        const idx = arr.indexOf(tab);
        const nextIdx = e.key === "ArrowRight" ? (idx + 1) % arr.length : (idx - 1 + arr.length) % arr.length;
        arr[nextIdx].focus();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-collections-section"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.collections-swiper', {
    slidesPerView: 2,
    spaceBetween: 20,
    centeredSlides: true,
    navigation: {
      nextEl: '.collections-swiper-button-next',
      prevEl: '.collections-swiper-button-prev',
    },
    pagination: {
        el: '.collections-swiper-pagination',
        type: 'fraction',
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-product-carousel"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.carousel-swiper', {
    slidesPerView: 1.1,
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    coverflowEffect: {
      rotate: 10,
      stretch: 0,
      depth: 100,
      modifier: 1,
    },
    pagination: {
    el: '.carousel-swiper-pagination',
    type: 'fraction',
    // optional: customize labels
    renderFraction: function (currentClass, totalClass) {
      return '<span class="' + currentClass + '"></span>'
           + ' / '
           + '<span class="' + totalClass + '"></span>';
    }
  },
    navigation: {
      nextEl: '.carousel-swiper-next',
      prevEl: '.carousel-swiper-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1366: {
        slidesPerView: 4,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-reviews"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.reviews-swiper', {
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.6,
      },
      1366: {
        slidesPerView: 3.6,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f1-the-solution"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.solution');
  
  sections.forEach(section => {
    const blocks = section.querySelectorAll('.solution__block');
    const images = section.querySelectorAll('.solution__media-wrapper .solution__image, .solution__media-wrapper .placeholder-svg');
    
    if (blocks.length === 0 || images.length === 0) return;
    
    images[0].classList.add('is-active');
    
    const options = {
      root: null,
      rootMargin: '-40% 0px -40% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = entry.target.dataset.index;
          
          images.forEach(img => img.classList.remove('is-active'));
          
          if (images[index]) {
            images[index].classList.add('is-active');
          }
        }
      });
    }, options);

    blocks.forEach(block => observer.observe(block));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
